export function videoEmbed(url) {
  const ytId = ((url || "").match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([\w-]{11})/) || [])[1];
  if (ytId) return { type: "youtube", src: `https://www.youtube.com/embed/${ytId}` };
  if (/youtu\.?be/.test(url || "")) return { type: "link", src: url };
  return { type: "file", src: url };
}

export function VideoPlayer({ url, title, className = "h-full w-full", testId }) {
  const v = videoEmbed(url);
  if (v.type === "youtube") {
    return (
      <iframe
        src={v.src}
        title={title || "Video"}
        className={className}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        data-testid={testId}
      />
    );
  }
  if (v.type === "link") {
    return (
      <div className={`${className} flex items-center justify-center bg-black`}>
        <a href={v.src} target="_blank" rel="noreferrer" className="text-accent-bright underline" data-testid={testId}>
          Watch video
        </a>
      </div>
    );
  }
  return <video src={v.src} controls playsInline className={className} data-testid={testId} />;
}
